import React from "react";

const EstimationColumn = ({ title, color }) => {
  return (
    <div className="col-md-3">
      <h6 className="mb-3">
        <span style={{color}}>●</span> {title}
      </h6>

      {[1,2,3].map(i => (
        <div key={i} className="card p-3 mb-3 estimation-card">
          <h6>TrulySell</h6>
          <small className="text-muted">Mobile App</small>

          <p className="small mt-2">
            Estimate ID: #ES00020 <br/>
            Amount: $1,23,000 <br/>
            Date: 15 Oct 2023 <br/>
            Expiry: 05 Nov 2026
          </p>

          <div className="small">👤 Dawn Mercha</div>
        </div>
      ))}
    </div>
  );
};

const Estimations = () => {
  return (
    <div className="container mt-4">
      <style>{`
        .estimation-card { box-shadow:0 6px 15px rgba(0,0,0,0.1); border-radius:10px; }
      `}</style>

      <h4>Estimations</h4>

      <div className="row">
        <EstimationColumn title="Draft" color="gray" />
        <EstimationColumn title="Sent" color="blue" />
        <EstimationColumn title="Accepted" color="green" />
        <EstimationColumn title="Declined" color="red" />
      </div>
    </div>
  );
};

export default Estimations;